import React from 'react';
import { resetPassword } from 'aws-amplify/auth';
import PropTypes from 'prop-types';
import ErrorMessage from '../../ErrorMessage';
import { useForgotPasswordContext } from '../ForgotPasswordContext';
import { LockIcon, MailIcon } from '../../../assets/icons';

function Step1({ nextStep }) {
  const { email, setEmail, error, setError } = useForgotPasswordContext();

  const ForgetPasswordFun = async (e) => {
    e.preventDefault();
    setError();
    try {
      const normalizedEmail = email.trim().toLowerCase();
      setEmail(normalizedEmail);
      await resetPassword({ username: normalizedEmail });
      nextStep();
    } catch (err) {
      setError(err.message || err.name || 'Failed to send reset code');
    }
  };

  return (
    <div className='px-6 py-9 sm:px-12 sm:py-11'>
      <div className='text-center'>
        <div className='mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-[#EBF4FB] text-[#0F2540]'>
          <LockIcon className='h-7 w-7' strokeWidth='1.75' />
        </div>
        <h3 className='font-serif text-2xl font-normal leading-tight text-[#0B1929]'>Forgot Password</h3>
        <p className='mt-2 text-sm leading-6 text-[#7A9AB0]'>Enter your email to receive a verification code</p>
      </div>
      <form onSubmit={ForgetPasswordFun} className='mt-7 space-y-4'>
        <div className='space-y-1.5'>
          <label htmlFor='formBasicEmail' className='block text-[11.5px] font-semibold text-[#7A9AB0]'>
            Email address
          </label>
          <div className='relative'>
            <MailIcon className='absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[#2E6BAD]' />
            <input
              id='formBasicEmail'
              className='flex h-12 w-full rounded-[10px] border-[1.5px] border-[#DDE6EF] bg-white px-3.5 py-3 pl-10 text-sm text-[#0B1929] outline-none transition placeholder:text-[#7A9AB0]/70 focus:border-[#2E6BAD] focus:ring-4 focus:ring-[#2E6BAD]/10'
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder='you@example.com'
            />
          </div>
        </div>
        <button
          className='inline-flex h-12 w-full items-center justify-center rounded-full bg-[#0B1929] px-7 text-sm font-semibold text-white transition hover:bg-[#0F2540] disabled:cursor-not-allowed disabled:bg-[#B8C9D9]'
          type='submit'
          disabled={email === ''}
        >
          Continue
        </button>
        {error && <ErrorMessage error={error} className='form-error-display' />}
        <div className='flex items-center justify-center gap-2 pt-1'>
          <p className='text-sm text-[#7A9AB0]'>Remember your password?</p>
          <a href='/login' className='text-sm font-medium text-[#2E6BAD] hover:underline'>
            Sign in
          </a>
        </div>
      </form>
    </div>
  );
}

Step1.propTypes = {
  nextStep: PropTypes.func,
};

export default Step1;
